// extracted by mini-css-extract-plugin
export var heading = "referencedSectionTitle-module--heading--f0d16";
export var stack = "referencedSectionTitle-module--stack--cfd82";
export var subHeading = "referencedSectionTitle-module--subHeading--3890e";